import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCalendar } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { calendarRoutes } from "./routes";

export const calendarRoute = [
  {
    path: calendarRoutes.list,
    lazy: async () => {
      const { CalendarOverviewPage } = await import("./pages/calendar-overview/CalendarOverviewPage");

      return {
        element: (
          <RequireAuth permission={canAccessCalendar}>
            <CalendarOverviewPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: calendarRoutes.reservationDetails,
    lazy: async () => {
      const { ReservationDetailsPage } = await import("./pages/reservation-details/ReservationDetailsPage");

      return { element: <ReservationDetailsPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
